import { render, staticRenderFns } from "./socket.vue?vue&type=template&id=08241872&scoped=true&"
import script from "./socket.vue?vue&type=script&lang=js&"
export * from "./socket.vue?vue&type=script&lang=js&"
import style0 from "./socket.vue?vue&type=style&index=0&id=08241872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08241872",
  null
  
)

export default component.exports